/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types',
	'./CustomVisualItems',
	'./NoCustomVisuals',
	'../util/CustomUtil'
], function(
	React,
	PropTypes,
	CustomVisualItems,
	NoCustomVisuals,
	CustomUtil
) {

	const { Component } = React;
	const CONTENT_CLASS = 'vis-custom-vis-content';

	class CustomVisualsContentComponent extends Component {

		constructor(props) {
			super(props);

			const { customVisAction } = this.props;
			customVisAction.setCustomVisualsContentComponent(this);

			this.state = {
				items: this.props.items,
				isRefreshing: this.props.isRefreshing
			};
		}

		componentWillReceiveProps(nextProps) {
			this.setState({
				items: nextProps.items,
				isRefreshing: nextProps.isRefreshing
			});
		}

		render () {
			const { items, isRefreshing } = this.state;
			const { handlers, customVisAction } = this.props;
			const hasItems = items.length > 0;
			if (isRefreshing) {
				return null;
			}

			return hasItems ?
				(
					<CustomVisualItems
						items={items}
						containerClass={CONTENT_CLASS}
						itemClass='prop-item'
						onContextMenuChange={this.onContextMenuChange.bind(this)}
						handlers={handlers}
						customVisAction={customVisAction}
					/>
				) : (
					<NoCustomVisuals
						handlers={handlers}
						customVisAction={customVisAction}
					/>
				);
		}

		onContextMenuChange (itemToUpdateOrDelete, action) {
			if (action === 'delete') {
				const { dashboardApi } = this.props;
				const { refreshCustomVisDefinitions } = this.props.handlers;

				return CustomUtil.deleteCustomVis(dashboardApi, itemToUpdateOrDelete.name, refreshCustomVisDefinitions)
					.then(items => {
						const { customVisAction } = this.props;
						customVisAction.setItems(items);
					});
			}
		}
	}

	CustomVisualsContentComponent.propTypes = {
		items: PropTypes.array.isRequired,
		handlers: PropTypes.shape({
			refreshCustomVisDefinitions: PropTypes.func.isRequired
		}).isRequired,
		isRefreshing: PropTypes.bool,
		dashboardApi: PropTypes.object.isRequired,
		customVisAction: PropTypes.object.isRequired
	};

	CustomVisualsContentComponent.defaultProps = {
		isRefreshing: false
	};

	return CustomVisualsContentComponent;
});
